import { connect, ConnectedProps } from 'react-redux';
import querystring from 'querystring';
import { StateType } from '../../../../../state/state.types';
import makeQueryParamsUtil from '../../../../../../../shared/makeQueryParamsUtil';
import { getQueryParamsFromState } from '../../../../state/utils';

const mapState = ({ results, queryParams }: StateType) => {
  let searchQueryUrl = querystring.stringify(
    makeQueryParamsUtil(
      getQueryParamsFromState({ ...queryParams, userQuery: results.query }),
    ),
  );
  searchQueryUrl += `&original_query_key=${queryParams.originalQueryKey}`;
  return {
    legalBasis: results.snippets.legalBasis,
    searchQueryUrl,
    query: results.query,
  };
};

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
